import "../styles/globals.css";
import { useEffect, StrictMode } from "react";
import { useRouter } from "next/router";
import * as gtag from "../utils/gtag";
import * as Sentry from "@sentry/node";

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    enabled: process.env.NODE_ENV !== "development",
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  });
}

function App({ Component, pageProps, err }) {
  const router = useRouter();
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      return;
    }
    const handleRouteChange = (url) => {
      gtag.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <StrictMode>
      <Component {...pageProps} err={err} />
    </StrictMode>
  );
}

export default App;
